import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Alert, Autocomplete, Divider, Grid, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { Loading } from "@/components/common/Loading";
import { CountryService } from "@/service/services/Country.service";
import { Props } from "./ModalCountryProvince.type";

export const ModalCountryProvince: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, province, onListProvince, clearState, departamentSelected } = props;

    console.log(departamentSelected)

    const [loading, setLoading] = useState<boolean>(false);

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    const [data, setData] = useState({
        id: province ? province.id : '',
        code: province ? province.code : '',
        name: province ? province.name : '',
        iddepartment: province ? province.iddepartment : '',
    });

    useEffect(() => {
        if(!departamentSelected){
            setTimeout(() => {
                closeModal && closeModal();
            }, 1000)
            return (
                setSnackBarConfig(prev => ({
                    ...prev, open: true,
                    severity: 'warning',
                    message: `Debe eleccionar un departamento`
                }))
            )
        }
    }, []);

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.code) errors.code = "codigo requerido";
        if(!values.name) errors.name = "nombre requerido";
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formData = {
            id: values.id,
            code: values.code,
            name: values.name,
            iddepartment : departamentSelected.id,
        }
        setLoading(true);
        if(province && actionSelected=='edit'){
            await CountryService.editProvince(formData, province.id).then((data) => {
                onListProvince && onListProvince(departamentSelected.id);
                closeModal && closeModal();
            })
        }else{
            await CountryService.createProvince(formData).then((data) => {
                if(data.data.status == false){
                    setLoading(false);
                    return (
                        setSnackBarConfig(prev => ({
                            ...prev, open: true,
                            severity: 'warning',
                            message: `${data.data.message || 'Ocurrió algún error.'}`
                        }))
                    );
                }
                onListProvince && onListProvince(departamentSelected.id);
                closeModal && closeModal();
            })
        }
        setLoading(false);
    }

    return(
        <>
        {loading && <Loading/>}

        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={(province && actionSelected=='edit') ? "Editar Provincia" : "Agregar Provincia"}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Código:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="code"
                                            variant="standard"
                                            type="text" 
                                            name="code"
                                            fullWidth
                                            value={values.code}
                                            onChange={handleChange}
                                            placeholder="codigo"
                                            error={errors.code && touched.code ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Nombre:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="name"
                                            variant="standard"
                                            type="text" 
                                            name="name"
                                            fullWidth
                                            value={values.name}
                                            onChange={handleChange}
                                            placeholder="nombre"
                                            error={errors.name && touched.name ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(province && actionSelected=='edit') ? "ACTUALIZAR" : "REGISTRAR"}
                                    cancelText="CANCELAR" 
                                    onCancel={closeModal}
                                    clearState={clearState}
                                    onConfirm={handleSubmit}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}